"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var SearchStore = (function () {
    function SearchStore(searchService) {
        var _this = this;
        this._searchTerm = "";
        this._isLoadingResults = true;
        this._results = [];
        this._count = 0;
        this.search = function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], __read(args_1), false), void 0, function (searchTerm) {
                var start, _a, projects, count, newResults;
                if (searchTerm === void 0) { searchTerm = this._searchTerm; }
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (searchTerm != this._searchTerm) {
                                this._isLoadingResults = true;
                                this._searchTerm = searchTerm;
                                start = 0;
                                this._results = [];
                            }
                            else {
                                if (this.allLoaded) {
                                    console.log("Already loaded all results for ".concat(this._searchTerm));
                                    this._isLoadingResults = false;
                                    return [2];
                                }
                                this._isLoadingResults = true;
                                start = this.numLoadedProjects;
                            }
                            return [4, this.searchService.searchProjects(searchTerm, start)];
                        case 1:
                            _a = _b.sent(), projects = _a.projects, count = _a.count;
                            newResults = __spreadArray(__spreadArray([], __read(this.results), false), __read(projects), false);
                            this._results = newResults;
                            this._count = count;
                            this._isLoadingResults = false;
                            return [2];
                    }
                });
            });
        };
        this.getProject = function (projectId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.searchService.getProject(projectId)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.searchService = searchService;
    }
    Object.defineProperty(SearchStore.prototype, "count", {
        get: function () {
            return this._count;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "searchTerm", {
        get: function () {
            return this._searchTerm;
        },
        set: function (value) {
            this._searchTerm = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "isLoadingResults", {
        get: function () {
            return this._isLoadingResults;
        },
        set: function (value) {
            this._isLoadingResults = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "numLoadedProjects", {
        get: function () {
            return this._results.length || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "allLoaded", {
        get: function () {
            return this.numLoadedProjects >= this._count;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], SearchStore.prototype, "_searchTerm", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SearchStore.prototype, "_isLoadingResults", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SearchStore.prototype, "_results", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], SearchStore.prototype, "_count", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], SearchStore.prototype, "count", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SearchStore.prototype, "numLoadedProjects", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SearchStore.prototype, "allLoaded", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SearchStore.prototype, "search", void 0);
    return SearchStore;
}());
exports.default = SearchStore;
